import {
  USER_ROLE,
  APPROVAL_STATUS,
  SUBSCRIPTION_STATUS,
} from "../system/global-enums";
import { SCREEN_PATH } from "../constants/global.constants";

import FAQ from "../views/faq/FAQ";
import Home from "../views/home/Home";
import FAQs from "../views/admin/faqs/FAQs";
import AboutUs from "../views/about-us/AboutUs";
import Agents from "../views/admin/agents/Agents";
import ContactUs from "../views/contant-us/ContactUs";
import Customers from "../views/admin/cutomers/Customers";
import MyProfile from "../views/my-profile/MyProfilePage";
import SellWithUs from "../views/sell-with-us/SellWithUs";
import SubAdmins from "../views/admin/sub-admins/SubAdmins";
import MyListing from "../views/agent/my-listing/MyListing";
import BuyProperty from "../views/buy-property/BuyProperty";
import AgentDetails from "../views/admin/agents/AgentDetails";
import PrivacyPolicy from "../views/privacy-policy/PrivacyPolicy";
import AgentProperties from "../views/admin/agents/AgentProperties";
import Subscription from "../views/admin/subscription/Subscription";
import AdminDashboard from "../views/admin/dashboard/AdminDashboard";
import CustomerDetails from "../views/admin/cutomers/CustomerDetails";
import AdminProperties from "../views/admin/properties/AdminProperties";
import CreateListing from "../views/agent/create-listing/CreateListing";
import MySubscriptions from "../views/my-subscriptions/MySubscriptions";
import SubscriptionPlan from "../views/subscription-plan/SubscriptionPlan";
import CountryDetails from "../views/admin/country-details/CountryDetails";
import PaymentHistory from "../views/admin/payment-history/PaymentHistory";
import PropertyDetailPage from "../views/property-detail/PropertyDetailPage";
import CountrySettings from "../views/admin/country-settings/CountrySettings";
import FavouriteProperty from "../views/favourite-property/FavouriteProperty";
import AdminPrivacyPolicy from "../views/admin/privacy-policy/AdminPrivacyPolicy";
import TermsAndConditions from "../views/terms-and-conditions/TermsAndConditions";
import AdminTermsAndConditions from "../views/admin/terms-and-conditions/AdminTermsAndConditions";
import CountriesEncyclopedia from "../views/countries-encyclopedia/CountriesEncyclopedia";
import CountriesEncyclopediaDetail from "../views/countries-encyclopedia/CountriesEncyclopediaDetail";

// Admin routes
const adminRoutes = [
  {
    id: 47,
    name: "Admin Dashboard",
    path: SCREEN_PATH.DEFAULT,
    component: AdminDashboard,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 1,
    name: "Admin Dashboard",
    path: SCREEN_PATH.ADMIN_DASHBOARD,
    component: AdminDashboard,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 2,
    name: "Admin Agents",
    path: SCREEN_PATH.ADMIN_AGENTS,
    component: Agents,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 3,
    name: "Admin Agents Details",
    path: SCREEN_PATH.ADMIN_AGENT_DETAILS,
    component: AgentDetails,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 4,
    name: "Admin Agents Properties",
    path: SCREEN_PATH.ADMIN_AGENT_PROPERTIES,
    component: AgentProperties,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 5,
    name: "Admin Countries",
    path: SCREEN_PATH.ADMIN_COUNTRIES,
    component: CountrySettings,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 6,
    name: "Admin Countries Details",
    path: SCREEN_PATH.ADMIN_COUNTRIES_DETAILS,
    component: CountryDetails,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 7,
    name: "Admin Customer",
    path: SCREEN_PATH.ADMIN_CUSTOMERS,
    component: Customers,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 8,
    name: "Admin Customer Details",
    path: SCREEN_PATH.ADMIN_CUSTOMERS_DETAILS,
    component: CustomerDetails,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 9,
    name: "Admin Payments",
    path: SCREEN_PATH.ADMIN_PAYMENTS,
    component: PaymentHistory,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 10,
    name: "Admin Properties",
    path: SCREEN_PATH.ADMIN_PROPERTIES,
    component: AdminProperties,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 11,
    name: "Admin Subscription",
    path: SCREEN_PATH.ADMIN_SUBSCRIPTION,
    component: Subscription,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 12,
    name: "Admin Sub Admins",
    path: SCREEN_PATH.ADMIN_SUB_ADMINS,
    component: SubAdmins,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 13,
    name: "Admin Add Country",
    path: SCREEN_PATH.ADMIN_COUNTRIES_ADD,
    component: CountryDetails,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 14,
    name: "Admin FAQ",
    path: SCREEN_PATH.ADMIN_FAQ,
    component: FAQs,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 15,
    name: "Admin Privacy Policy",
    path: SCREEN_PATH.ADMIN_PRIVACY_POLICY,
    component: AdminPrivacyPolicy,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 16,
    name: "Admin Terms and Conditions",
    path: SCREEN_PATH.ADMIN_TERMS_AND_CONDITIONS,
    component: AdminTermsAndConditions,
    role: USER_ROLE.ADMIN,
  },
  {
    id: 37,
    name: "Admin Property Details",
    path: SCREEN_PATH.ADMIN_PROPERTY_DETAILS,
    component: PropertyDetailPage,
    role: USER_ROLE.ADMIN,
  },
];

// Agent Routes
const agentRoutes = (user, hasMultipleRoles) => {
  const routes = [
    {
      id: 49,
      name: "My Profile",
      path: SCREEN_PATH.DEFAULT,
      component: MyProfile,
      role: USER_ROLE.AGENT,
    },
    {
      id: 17,
      name: "My Profile",
      path: SCREEN_PATH.AGENT_PROFILE,
      component: MyProfile,
      role: USER_ROLE.AGENT,
    },
  ];

  if (user?.approvalStatus === APPROVAL_STATUS.APPROVED) {
    routes.push(
      {
        id: 18,
        name: "My Listing",
        path: SCREEN_PATH.MY_LISTING,
        component: MyListing,
        role: USER_ROLE.AGENT,
      },
      {
        id: 19,
        name: "Create Listing",
        path: SCREEN_PATH.CREATE_LISTING,
        component: CreateListing,
        role: USER_ROLE.AGENT,
      },
      {
        id: 20,
        name: "Edit Listing",
        path: SCREEN_PATH.EDIT_PROPERTY,
        component: CreateListing,
        role: USER_ROLE.AGENT,
      },
      {
        id: 21,
        name: "Agent About Us",
        path: SCREEN_PATH.AGENT_ABOUT_US,
        component: AboutUs,
        role: USER_ROLE.AGENT,
      },
      {
        id: 22,
        name: "Agent Contact Us",
        path: SCREEN_PATH.AGENT_CONTACT_US,
        component: ContactUs,
        role: USER_ROLE.AGENT,
      },
      {
        id: 24,
        name: "Agent Property Details",
        path: SCREEN_PATH.AGENT_PROPERTY_DETAILS,
        component: PropertyDetailPage,
        role: USER_ROLE.AGENT,
      },
      {
        id: 25,
        name: "FAQ",
        path: SCREEN_PATH.AGENT_FAQ,
        component: FAQ,
        role: USER_ROLE.AGENT,
      },
      {
        id: 26,
        name: "Agent Privacy Policy",
        path: SCREEN_PATH.AGENT_PRIVACY_POLICY,
        component: PrivacyPolicy,
        role: USER_ROLE.AGENT,
      },
      {
        id: 27,
        name: "Agent Terms and Conditions",
        path: SCREEN_PATH.AGENT_TERMS_AND_CONDITIONS,
        component: TermsAndConditions,
        role: USER_ROLE.AGENT,
      }
    );
  }
  if (
    user?.approvalStatus === APPROVAL_STATUS.APPROVED &&
    !user?.isPaymentDisabled
  ) {
    routes.push(
      {
        id: 23,
        name: "Subscription",
        path: SCREEN_PATH.AGENT_SUBSCRIPTION_PLANS,
        component: SubscriptionPlan,
        role: USER_ROLE.AGENT,
      },
      {
        id: 28,
        name: "My Subscriptions",
        path: SCREEN_PATH.AGENT_MY_SUBSCRIPTIONS,
        component: MySubscriptions,
        role: USER_ROLE.AGENT,
      }
    );
  }

  if (!hasMultipleRoles) {
    routes.push({
      id: 29,
      name: "Buy Property",
      path: "Buy-Property",
      component: BuyProperty,
      role: USER_ROLE.AGENT,
    });
  }

  return routes;
};

// User Routes
const userRoutes = (user, hasMultipleRoles) => {
  const routes = [
    {
      id: 48,
      name: "Home",
      path: SCREEN_PATH.DEFAULT,
      component: Home,
      role: USER_ROLE.USER,
    },
    {
      id: 30,
      name: "Home",
      path: SCREEN_PATH.HOME,
      component: Home,
      role: USER_ROLE.USER,
    },
    {
      id: 31,
      name: "Property Detail",
      path: SCREEN_PATH.PROPERTY_DETAIL,
      component: PropertyDetailPage,
      role: USER_ROLE.USER,
    },
    {
      id: 32,
      name: "My Profile",
      path: SCREEN_PATH.MY_PROFILE,
      component: MyProfile,
      role: USER_ROLE.USER,
    },
    {
      id: 33,
      name: "Favourites",
      path: SCREEN_PATH.FAVOURITES,
      component: FavouriteProperty,
      role: USER_ROLE.USER,
    },
    {
      id: 34,
      name: "About Us",
      path: SCREEN_PATH.ABOUT_US,
      component: AboutUs,
      role: USER_ROLE.USER,
    },
    {
      id: 35,
      name: "Contact Us",
      path: SCREEN_PATH.CONTACT_US,
      component: ContactUs,
      role: USER_ROLE.USER,
    },
    {
      id: 36,
      name: "Favourite Property Detail",
      path: SCREEN_PATH.FAVOURITES_PROPERTY_DETAIL,
      component: PropertyDetailPage,
      role: USER_ROLE.USER,
      isFromFavourites: true,
    },
    {
      id: 38,
      name: "Agent Property Details for Admin",
      path: SCREEN_PATH.ADMIN_AGENT_PROPERTY_DETAILS,
      component: PropertyDetailPage,
      role: USER_ROLE.USER,
    },
    {
      id: 39,
      name: "FAQ",
      path: SCREEN_PATH.FAQ,
      component: FAQ,
      role: USER_ROLE.USER,
    },
    {
      id: 40,
      name: "Subscription",
      path: SCREEN_PATH.SUBSCRIPTION_PLANS,
      component: SubscriptionPlan,
      role: USER_ROLE.USER,
    },
    {
      id: 41,
      name: "User Privacy Policy",
      path: SCREEN_PATH.PRIVACY_POLICY,
      component: PrivacyPolicy,
      role: USER_ROLE.USER,
    },
    {
      id: 42,
      name: "User Terms and Conditions",
      path: SCREEN_PATH.TERMS_AND_CONDITIONS,
      component: TermsAndConditions,
      role: USER_ROLE.USER,
    },
    {
      id: 45,
      name: "Countries Encyclopedia",
      path: SCREEN_PATH.COUNTRIES_ENCYCLOPEDIA,
      component: CountriesEncyclopedia,
      role: USER_ROLE.USER,
    },
    {
      id: 46,
      name: "Country Encyclopedia Detail",
      path: SCREEN_PATH.COUNTRY_ENCYCLOPEDIA_DETAIL,
      component: CountriesEncyclopediaDetail,
      role: USER_ROLE.USER,
    },
  ];

  if (user?.subscriptionStatus !== SUBSCRIPTION_STATUS.NOT_SUBSCRIBED) {
    routes.push({
      id: 43,
      name: "My Subscriptions",
      path: SCREEN_PATH.MY_SUBSCRIPTIONS,
      component: MySubscriptions,
      role: USER_ROLE.USER,
    });
  }
  if (!hasMultipleRoles) {
    routes.push({
      id: 44,
      name: "Sell With Us",
      path: "Sell-With-Us",
      component: SellWithUs,
      role: USER_ROLE.USER,
    });
  }
  return routes;
};

export const allRoutes = (user, hasMultipleRoles) => {
  const routes = [
    ...adminRoutes,
    ...agentRoutes(user, hasMultipleRoles),
    ...userRoutes(user, hasMultipleRoles),
  ];
  return routes;
};
